import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { IUser, UserActionTypes } from "../models";
import { FACEBOOK_LOGIN } from "../types";

export default (data: { accessToken: string, lang: string }) => 
    async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    dispatch({
        type: FACEBOOK_LOGIN,
        payload: {
            loading: true,
        },
    });
    try {
        const res = await api.post<{ user: IUser, success: boolean }>("/facebook-login", data);
        dispatch({
            type: FACEBOOK_LOGIN,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        dispatch({
            type: FACEBOOK_LOGIN,
            payload: {
                error: true,
            },
        });
    }
};
